import DeliveryWindowModal from 'components/Checkout/Sections/SddSections/SddSection/DeliveryWindow/DeliveryWindowModal/DeliveryWindowModal';

export default DeliveryWindowModal;
